import { getUseServiceWithSubscriptionKeys } from '@webtrader/core/utils';

import editOrderService from './service';

// Example of getting useService hook with specified subscription keys
// export const useEditOrderWithKeys = (subscriptionKeys: (keyof IOrderFormContext)[]) =>
//   useService(editOrderService, serviceSelector<typeof editOrderService, IOrderFormContext>(subscriptionKeys));

export const useEditOrderWithKeys = getUseServiceWithSubscriptionKeys(editOrderService);

export { editOrderService };
